/* Continue-your-offer FAB — site-wide indicator + entry point to /pages/submit-offer.
 *
 * Reads `tk-co-cart` from sessionStorage, updates the count badge, and shows
 * the floating button whenever the cart has at least one item. Listens for
 * the `tk-cart-changed` CustomEvent so any component that mutates the cart
 * (product-sell-v2, submit-offer, future cart drawer) can re-render the badge
 * without a page reload.
 *
 * SSR-safe: the cart-icon snippet renders with `hidden` so the markup is
 * present but invisible on first paint; this script flips it on after read.
 * CSS fixes the width so toggling visibility does not cause CLS.
 */
(function () {
  'use strict';
  var STORAGE_KEY = 'tk-co-cart';
  var RE_VALID = /^\d+$/;
  var DESIGN_MODE = Boolean(window.Shopify && Shopify.designMode);

  function readCart() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }

  function update() {
    var icons = document.querySelectorAll('[data-cart-icon]');
    if (!icons.length) return;
    var cart = readCart().filter(function (d) {
      if (!d) return false;
      if (d.productId && RE_VALID.test(String(d.productId))) return false;
      return Boolean(d.deviceName || d.deviceSlug);
    });
    var count = cart.length;
    icons.forEach(function (icon) {
      var display = icon.querySelector('[data-cart-count-display]');
      var badge = icon.querySelector('[data-cart-count-badge]');
      if (count > 0 || DESIGN_MODE) {
        icon.hidden = false;
        icon.setAttribute('data-cart-count', String(count || 1));
        if (display) display.textContent = count > 0 ? count + ' ' + (count === 1 ? 'device' : 'devices') : 'Design preview';
        if (badge) {
          badge.hidden = count === 0;
          badge.textContent = count > 9 ? '9+' : String(count || 1);
        }
        // Distinct label so screen readers know how many items.
        icon.setAttribute('aria-label', 'Continue your offer (' + count + ' ' + (count === 1 ? 'device' : 'devices') + ')');
      } else {
        icon.hidden = true;
        icon.setAttribute('data-cart-count', '0');
        if (display) display.textContent = '0 devices';
        if (badge) badge.hidden = true;
        icon.setAttribute('aria-label', 'Continue your offer');
      }
    });
  }

  // Run on first paint, after the cart-icon snippet has hydrated.
  function init() {
    update();
    // Cross-component sync — any mutation to tk-co-cart should re-render.
    document.addEventListener('tk-cart-changed', update);
    // Storage event for cross-tab updates (rare, but cheap to support).
    window.addEventListener('storage', function (e) { if (e.key === STORAGE_KEY) update(); });
  }

  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init, { once: true });
  }
})();
